import { useEffect } from 'react';
import '../styles/SideDrawer.css';

export default function SideDrawer({
  open,
  onClose,
  side = 'right',
  title,
  mode = 'light',
  children,
}) {
  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose && onClose();
    };

    // Prevent background scroll while drawer is open
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);

  if (!open) return null;

  const isDark = mode === 'dark';
  const sideClass = side === 'left' ? 'side_drawer_left' : 'side_drawer_right';

  return (
    <div className="side_drawer_root" role="dialog" aria-modal="true">
      <button
        className="side_drawer_backdrop"
        aria-label="Close"
        onClick={() => onClose && onClose()}
        type="button"
      />

      <aside
        className={`side_drawer ${sideClass} ${
          isDark ? 'side_drawer_dark' : 'side_drawer_light'
        }`}
      >
        <div className="side_drawer_header">
          <div className="side_drawer_title">{title}</div>
          <button
            className={`side_drawer_close ${
              isDark ? 'side_drawer_close_dark' : ''
            }`}
            onClick={() => onClose && onClose()}
            type="button"
          >
            ✕
          </button>
        </div>

        <div className="side_drawer_body">{children}</div>
      </aside>
    </div>
  );
}
